export default __webpack_public_path__ + "static/media/two_stone.6df5f819.webp";